var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vis-tile',{attrs:{"title":"PLS-DA VIP Plot","svg-download":""}},[_c('vip-plot',{attrs:{"vip-scores":_vm.vipScores}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }